// Sell.js (모듈화 및 수정된 코드)
import { useState, useEffect } from 'react';

import ImageUploadSection from './components/ImageUploadSection/ImageUploadSection';
import DescriptionForm from './components/DescriptionForm/DescriptionForm';

import styles from './Sell.module.css';

function Sell() {
    const [formData, setFormData] = useState({
        guitarName: '',
        usagePeriod: '',
        price: '',
        description: '',
        etc: '',
    });

    const [isFormValid, setIsFormValid] = useState(false);

    // 유효성 검사 함수
    useEffect(() => {
        const isValid = Object.values(formData).every(value => value.trim() !== '');
        setIsFormValid(isValid);
    }, [formData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('판매 등록 완료!');
        console.log('Form Data:', formData);
    };

    return (
        <div className={`${styles.sellPage} common-padding`}>
            <form onSubmit={handleSubmit} className={styles.sellForm}>
                {/* Image Section Wrapper */}
                <div className={styles.imageSectionsWrapper}>
                    <ImageUploadSection
                        title="정면 사진"
                        instructions={[
                            '제품의 정면을 찍어주세요.',
                            '헤드부터 바디까지 전체 모습을 찍어주세요.',
                            '밝은 곳에서 찍어주세요.',
                        ]}
                    />

                    <ImageUploadSection
                        title="후면 사진"
                        instructions={[
                            '제품의 후면을 찍어주세요.',
                            '흠집, 기스 등의 흔적이 보이도록 찍어주세요.',
                            '밝은 곳에서 찍어주세요.',
                        ]}
                    />
                </div>

                {/* Description Section */}
                <div className={styles.descriptionSection}>
                    <DescriptionForm formData={formData} handleInputChange={handleInputChange} />

                    {/* 버튼을 감싸는 div에 title 추가 */}
                    <div className={styles.buttonWrapper} title={!isFormValid ? '모든 폼을 작성해주세요.' : ''}>
                        <button
                            type="submit"
                            className={`${styles.submitButton} ${!isFormValid ? styles.disabled : ''}`}
                            disabled={!isFormValid}
                        >
                            Sales Register
                        </button>
                    </div>
                </div>

            </form>
        </div>
    );
};

export default Sell;